module.exports = __webpack_public_path__ + "assets/advantage-badge-49f146.svg";